import React from 'react';

export const CloseIcon = ({ size = 24, color }) => (
<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill={color}>
  <path fillRule="evenodd" clipRule="evenodd" d="M2.96309 2.97603C3.1974 2.74171 3.5773 2.74171 3.81162 2.97603L11.9871 11.1515L20.1625 2.97603C20.3968 2.74171 20.7767 2.74171 21.011 2.97603C21.2453 3.21034 21.2453 3.59024 21.011 3.82456L12.8356 12L21.011 20.1754C21.2453 20.4098 21.2453 20.7897 21.011 21.024C20.7767 21.2583 20.3968 21.2583 20.1625 21.024L11.9871 12.8485L3.81162 21.024C3.5773 21.2583 3.1974 21.2583 2.96309 21.024C2.72877 20.7897 2.72877 20.4098 2.96309 20.1754L11.1385 12L2.96309 3.82456C2.72877 3.59024 2.72877 3.21034 2.96309 2.97603Z" fill={color} />
</svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Close.icon.jsx